// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file family_service.proto (package pipeex.family.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ParameterDataTypeHint, StartOperationResponseSchema } from "./revit_service_pb";
import { file_revit_service } from "./revit_service_pb";
import type { ProjectParameterUndoEntry } from "./parameter_undo_pb";
import { file_parameter_undo } from "./parameter_undo_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file family_service.proto.
 */
export const file_family_service: GenFile = /*@__PURE__*/
  fileDesc("ChRmYW1pbHlfc2VydmljZS5wcm90bxIQcGlwZWV4LmZhbWlseS52MSKgAQogR2V0RmFtaWxpZXNXaXRoUGFyYW1ldGVyc1JlcXVlc3QSFwoPcGFyYW1ldGVyX25hbWVzGAEgAygJEhkKEXNjb3BlZF9mYW1pbHlfaWRzGAIgAygJEkgKFHJlcXVlc3RlZF9wYXJhbWV0ZXJzGAMgAygLMioucGlwZWV4LmZhbWlseS52MS5SZXF1ZXN0ZWRQYXJhbWV0ZXJJbnRlbnQiUwoYUmVxdWVzdGVkUGFyYW1ldGVySW50ZW50EgwKBG5hbWUYASABKAkSEwoLZGVzdGluYXRpb24YAiABKAkSFAoMYmluZGluZ19raW5kGAMgASgJIs0CChtGYW1pbHlTY29wZVJlcXVpcmVtZW50SW5wdXQSCwoDa2V5GAEgASgJEhYKDnBhcmFtZXRlcl9uYW1lGAIgASgJEhMKC2Rlc3RpbmF0aW9uGAMgASgJEhQKDGJpbmRpbmdfa2luZBgEIAEoCRITCgt0YXJnZXRfa2luZBgFIAEoCRISCgpjYXRlZ29yaWVzGAYgAygJEhQKDG9iamVjdF90eXBlcxgHIAMoCRIkChxkaXNjcmltaW5hdG9yX3BhcmFtZXRlcl9uYW1lGAggASgJEiEKGWRpc2NyaW1pbmF0b3JfZGVzdGluYXRpb24YCSABKAkSIgoaZGlzY3JpbWluYXRvcl9iaW5kaW5nX2tpbmQYCiABKAkSGgoSZW1wdHlfbWF0Y2hfcG9saWN5GAsgASgJEhYKDmRhdGFfdHlwZV9oaW50GAwgASgJImkKIkZhbWlseVJlcXVpcmVtZW50QXNzZXNzbWVudFJlcXVlc3QSQwoMcmVxdWlyZW1lbnRzGAEgAygLMi0ucGlwZWV4LmZhbWlseS52MS5GYW1pbHlTY29wZVJlcXVpcmVtZW50SW5wdXQibQoWRmFtaWx5U2NvcGVDb25mbGljdER0bxIRCgllbnRpdHlfaWQYASABKAkSEwoLZW50aXR5X25hbWUYAiABKAkSGwoTYWN0dWFsX2JpbmRpbmdfa2luZBgDIAEoCRIOCgZyZWFzb24YBCABKAkisgEKGEZhbWlseVNjb3BlQXNzZXNzbWVudER0bxIXCg9yZXF1aXJlbWVudF9rZXkYASABKAkSEQoJc2F0aXNmaWVkGAIgASgIEg4KBnN0YXR1cxgDIAEoCRIdChVtYXRjaGluZ19lbnRpdHlfY291bnQYBCABKAUSOwoJY29uZmxpY3RzGAUgAygLMigucGlwZWV4LmZhbWlseS52MS5GYW1pbHlTY29wZUNvbmZsaWN0RHRvIqABCiNGYW1pbHlSZXF1aXJlbWVudEFzc2Vzc21lbnRSZXNwb25zZRISCgppc19zdWNjZXNzGAEgASgIEg0KBWVycm9yGAIgASgJEhUKDW1vZGVsX3ZlcnNpb24YAyABKAMSPwoLYXNzZXNzbWVudHMYBCADKAsyKi5waXBlZXguZmFtaWx5LnYxLkZhbWlseVNjb3BlQXNzZXNzbWVudER0byKRAQoURmFtaWx5UGFyYW1ldGVyVmFsdWUSFAoMcGFyYW1ldGVyX2lkGAEgASgJEhYKDnBhcmFtZXRlcl9uYW1lGAIgASgJEg0KBXZhbHVlGAMgASgJEhQKDGlzX3JlYWRfb25seRgEIAEoCBITCgtpc19pbnN0YW5jZRgFIAEoCBIRCglkYXRhX3R5cGUYBiABKAkiawoNRmFtaWx5VHlwZUR0bxIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEkAKEHBhcmFtZXRlcl92YWx1ZXMYAyADKAsyJi5waXBlZXguZmFtaWx5LnYxLkZhbWlseVBhcmFtZXRlclZhbHVlIpYBCglGYW1pbHlEdG8SCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCRIQCghjYXRlZ29yeRgDIAEoCRITCgtpc19lZGl0YWJsZRgEIAEoCBIYChBpc19zeXN0ZW1fZmFtaWx5GAUgASgIEi4KBXR5cGVzGAYgAygLMh8ucGlwZWV4LmZhbWlseS52MS5GYW1pbHlUeXBlRHRvInUKIUdldEZhbWlsaWVzV2l0aFBhcmFtZXRlcnNSZXNwb25zZRISCgppc19zdWNjZXNzGAEgASgIEg0KBWVycm9yGAIgASgJEi0KCGZhbWlsaWVzGAMgAygLMhsucGlwZWV4LmZhbWlseS52MS5GYW1pbHlEdG8iHwodR2V0QXZhaWxhYmxlUGFyYW1ldGVyc1JlcXVlc3Qi4wEKEkF2YWlsYWJsZVBhcmFtZXRlchIMCgRuYW1lGAEgASgJEg0KBWxhYmVsGAIgASgJEhYKDnBhcmFtZXRlcl90eXBlGAMgASgJEg0KBWdyb3VwGAQgASgJEhMKC2lzX2luc3RhbmNlGAUgASgIEhEKCWRhdGFfdHlwZRgGIAEoCRIaChJpc19wcm9qZWN0X2JpbmRpbmcYByABKAgSEgoKY2F0ZWdvcmllcxgIIAMoCRIxCgZzb3VyY2UYCSABKA4yIS5waXBlZXguZmFtaWx5LnYxLlBhcmFtZXRlclNvdXJjZSJ9Ch5HZXRBdmFpbGFibGVQYXJhbWV0ZXJzUmVzcG9uc2USEgoKaXNfc3VjY2VzcxgBIAEoCBINCgVlcnJvchgCIAEoCRI4CgpwYXJhbWV0ZXJzGAMgAygLMiQucGlwZWV4LmZhbWlseS52MS5BdmFpbGFibGVQYXJhbWV0ZXIivwEKDlBpcGVFbGVtZW50RHRvEgoKAmlkGAEgASgJEhMKC2ZhbWlseV9uYW1lGAIgASgJEhEKCXR5cGVfbmFtZRgDIAEoCRIQCghjYXRlZ29yeRgEIAEoCRJAChBwYXJhbWV0ZXJfdmFsdWVzGAUgAygLMiYucGlwZWV4LmZhbWlseS52MS5GYW1pbHlQYXJhbWV0ZXJWYWx1ZRIUCgxlbGVtZW50X25hbWUYBiABKAkSDwoHdHlwZV9pZBgHIAEoCSJjCiBVcGRhdGVGYW1pbHlUeXBlUGFyYW1ldGVyUmVxdWVzdBIYChBmYW1pbHlfdHlwZV9uYW1lGAEgASgJEhYKDnBhcmFtZXRlcl9uYW1lGAIgASgJEg0KBXZhbHVlGAMgASgJIoEBCiFVcGRhdGVGYW1pbHlUeXBlUGFyYW1ldGVyUmVzcG9uc2USEgoKaXNfc3VjY2VzcxgBIAEoCBINCgVlcnJvchgCIAEoCRITCgtmYW1pbHlfdHlwZRgDIAEoCRIRCglwYXJhbWV0ZXIYBCABKAkSEQoJbmV3X3ZhbHVlGAUgASgJIqEBChlGYW1pbHlUeXBlUGFyYW1ldGVyVXBkYXRlEhMKC2ZhbWlseV90eXBlGAEgASgJEhYKDnBhcmFtZXRlcl9uYW1lGAIgASgJEg0KBXZhbHVlGAMgASgJEhYKDmZhbWlseV90eXBlX2lkGAQgASgJEhoKEnRhcmdldF9lbGVtZW50X2lkcxgFIAMoCRIUCgxiaW5kaW5nX2tpbmQYBiABKAkiYQohVXBkYXRlRmFtaWx5VHlwZVBhcmFtZXRlcnNSZXF1ZXN0EjwKB3VwZGF0ZXMYASADKAsyKy5waXBlZXguZmFtaWx5LnYxLkZhbWlseVR5cGVQYXJhbWV0ZXJVcGRhdGUimgEKIlVwZGF0ZUZhbWlseVR5cGVQYXJhbWV0ZXJzUmVzcG9uc2USEgoKaXNfc3VjY2VzcxgBIAEoCBINCgVlcnJvchgCIAEoCRIVCg10b3RhbF91cGRhdGVzGAMgASgFEhUKDXN1Y2Nlc3NfY291bnQYBCABKAUSEwoLZXJyb3JfY291bnQYBSABKAUSDgoGZXJyb3JzGAYgAygJIlMKFkVsZW1lbnRQYXJhbWV0ZXJVcGRhdGUSEgoKZWxlbWVudF9pZBgBIAEoCRIWCg5wYXJhbWV0ZXJfbmFtZRgCIAEoCRINCgV2YWx1ZRgDIAEoCSJbCh5VcGRhdGVFbGVtZW50UGFyYW1ldGVyc1JlcXVlc3QSOQoHdXBkYXRlcxgBIAMoCzIoLnBpcGVleC5mYW1pbHkudjEuRWxlbWVudFBhcmFtZXRlclVwZGF0ZSKXAQofVXBkYXRlRWxlbWVudFBhcmFtZXRlcnNSZXNwb25zZRISCgppc19zdWNjZXNzGAEgASgIEg0KBWVycm9yGAIgASgJEhUKDXRvdGFsX3VwZGF0ZXMYAyABKAUSFQoNc3VjY2Vzc19jb3VudBgEIAEoBRITCgtlcnJvcl9jb3VudBgFIAEoBRIOCgZlcnJvcnMYBiADKAkiOAocTG9hZEZhbWlseUludG9Qcm9qZWN0UmVxdWVzdBIYChBmYW1pbHlfZmlsZV9wYXRoGAEgASgJIqIBCh1Mb2FkRmFtaWx5SW50b1Byb2plY3RSZXNwb25zZRISCgppc19zdWNjZXNzGAEgASgIEg0KBWVycm9yGAIgASgJEhEKCWZhbWlseV9pZBgDIAEoCRITCgtmYW1pbHlfbmFtZRgEIAEoCRIQCghjYXRlZ29yeRgFIAEoCRITCgt0eXBlc19jb3VudBgGIAEoBRIPCgdtZXNzYWdlGAcgASgJItgDCiZBZGRQYXJhbWV0ZXJzVG9TcGVjaWZpY0ZhbWlsaWVzUmVxdWVzdBISCgpmYW1pbHlfaWRzGAEgAygJEhcKD3BhcmFtZXRlcl9uYW1lcxgCIAMoCRIfChdpbmNsdWRlX3N5c3RlbV9mYW1pbGllcxgDIAEoCBISCgpjYXRlZ29yaWVzGAQgAygJEiIKGnNoYXJlZF9wYXJhbWV0ZXJfZmlsZV9wYXRoGAUgASgJEiUKHXNoYXJlZF9wYXJhbWV0ZXJfZmlsZV9jb250ZW50GAYgASgJEhQKDGJpbmRpbmdfa2luZBgHIAEoCRIbChN0YXJnZXRfb2JqZWN0X3R5cGVzGAggAygJEh4KFmV4cGVjdGVkX2RvY3VtZW50X25hbWUYCSABKAkSHgoWZXhwZWN0ZWRfZG9jdW1lbnRfcGF0aBgKIAEoCRJEChRwYXJhbWV0ZXJfdHlwZV9oaW50cxgLIAMoCzImLnBpcGVleC5yZXZpdC52MS5QYXJhbWV0ZXJEYXRhVHlwZUhpbnQSIgoab2JqZWN0X3R5cGVfcGFyYW1ldGVyX25hbWUYDCABKAkSJAoccmVxdWlyZV9yZXZlcnNpYmxlX211dGF0aW9ucxgNIAEoCCJqChRNb2RpZmllZEZhbWlseVJlc3VsdBITCgtmYW1pbHlfbmFtZRgBIAEoCRIRCglmYW1pbHlfaWQYAiABKAkSEAoIY2F0ZWdvcnkYAyABKAkSGAoQYWRkZWRfcGFyYW1ldGVycxgEIAMoCSLoBAonQWRkUGFyYW1ldGVyc1RvU3BlY2lmaWNGYW1pbGllc1Jlc3BvbnNlEhIKCmlzX3N1Y2Nlc3MYASABKAgSDQoFZXJyb3IYAiABKAkSHwoXbW9kaWZpZWRfZmFtaWxpZXNfY291bnQYAyABKAUSIgoac3lzdGVtX2ZhbWlseV9wYXJhbXNfYWRkZWQYBCABKAUSQQoRbW9kaWZpZWRfZmFtaWxpZXMYBSADKAsyJi5waXBlZXguZmFtaWx5LnYxLk1vZGlmaWVkRmFtaWx5UmVzdWx0Eg8KB21lc3NhZ2UYBiABKAkSJAoccmVzb2x2ZWRfZmFtaWx5X3RhcmdldF9jb3VudBgHIAEoBRIlCh1wcm9jZXNzZWRfZmFtaWx5X3RhcmdldF9jb3VudBgIIAEoBRIbChNvcGVuZWRfZmFtaWx5X2NvdW50GAkgASgFEiYKHnVubW9kaWZpZWRfZmFtaWx5X3RhcmdldF9jb3VudBgKIAEoBRInCh9leGlzdGluZ19mYW1pbHlfcGFyYW1ldGVyX2NvdW50GAsgASgFEhYKDmNvbmZsaWN0X2NvdW50GAwgASgFEhUKDWZhaWx1cmVfY291bnQYDSABKAUSRQoMdW5kb19lbnRyaWVzGA4gAygLMi8ucGlwZWV4LmZhbWlseS52MS5VbmRvQWRkZWRGYW1pbHlQYXJhbWV0ZXJFbnRyeRJQChRwcm9qZWN0X3VuZG9fZW50cmllcxgPIAMoCzIyLnBpcGVleC5wYXJhbWV0ZXJ1bmRvLnYxLlByb2plY3RQYXJhbWV0ZXJVbmRvRW50cnkilgEKHVVuZG9BZGRlZEZhbWlseVBhcmFtZXRlckVudHJ5EhEKCWZhbWlseV9pZBgBIAEoCRITCgtmYW1pbHlfbmFtZRgCIAEoCRIWCg5wYXJhbWV0ZXJfbmFtZRgDIAEoCRIWCg5leGlzdGVkX2JlZm9yZRgEIAEoCBIdChVwcmV2aW91c19iaW5kaW5nX2tpbmQYBSABKAkisAEKLFVuZG9BZGRlZFBhcmFtZXRlcnNUb1NwZWNpZmljRmFtaWxpZXNSZXF1ZXN0EkAKB2VudHJpZXMYASADKAsyLy5waXBlZXguZmFtaWx5LnYxLlVuZG9BZGRlZEZhbWlseVBhcmFtZXRlckVudHJ5Eh4KFmV4cGVjdGVkX2RvY3VtZW50X25hbWUYAiABKAkSHgoWZXhwZWN0ZWRfZG9jdW1lbnRfcGF0aBgDIAEoCSLVAQotVW5kb0FkZGVkUGFyYW1ldGVyc1RvU3BlY2lmaWNGYW1pbGllc1Jlc3BvbnNlEhIKCmlzX3N1Y2Nlc3MYASABKAgSDQoFZXJyb3IYAiABKAkSHQoVdW5kb25lX2ZhbWlsaWVzX2NvdW50GAMgASgFEh8KF3JlbW92ZWRfcGFyYW1ldGVyX2NvdW50GAQgASgFEiAKGHJlc3RvcmVkX3BhcmFtZXRlcl9jb3VudBgFIAEoBRIOCgZlcnJvcnMYBiADKAkSDwoHbWVzc2FnZRgHIAEoCSKZAwoXR2V0UXVpY2tGaWxsRGF0YVJlcXVlc3QSFwoPcGFyYW1ldGVyX25hbWVzGAEgAygJEkAKDnNuYXBzaG90X3NoYXBlGAIgASgOMigucGlwZWV4LmZhbWlseS52MS5RdWlja0ZpbGxTbmFwc2hvdFNoYXBlEhkKEXNjb3BlZF9mYW1pbHlfaWRzGAMgAygJEhsKE3Njb3BlZF9mYW1pbHlfbmFtZXMYBCADKAkSHwoXc2NvcGVkX2ZhbWlseV90eXBlX2tleXMYBSADKAkSGgoSc2NvcGVkX2VsZW1lbnRfaWRzGAYgAygJEh0KFXNjb3BlZF9jYXRlZ29yeV9uYW1lcxgHIAMoCRIlCh1kZWZlcl91bnBsYWNlZF9mYW1pbHlfY2F0YWxvZxgIIAEoCBJIChRyZXF1ZXN0ZWRfcGFyYW1ldGVycxgJIAMoCzIqLnBpcGVleC5mYW1pbHkudjEuUmVxdWVzdGVkUGFyYW1ldGVySW50ZW50Eh4KFm1hcHBpbmdfcmVhZGluZXNzX29ubHkYCiABKAgiogIKGEdldFF1aWNrRmlsbERhdGFSZXNwb25zZRISCgppc19zdWNjZXNzGAEgASgIEg0KBWVycm9yGAIgASgJEi0KCGZhbWlsaWVzGAMgAygLMhsucGlwZWV4LmZhbWlseS52MS5GYW1pbHlEdG8SQgoUYXZhaWxhYmxlX3BhcmFtZXRlcnMYBCADKAsyJC5waXBlZXguZmFtaWx5LnYxLkF2YWlsYWJsZVBhcmFtZXRlchI3Cg1waXBlX2VsZW1lbnRzGAUgAygLMiAucGlwZWV4LmZhbWlseS52MS5QaXBlRWxlbWVudER0bxIVCg1tb2RlbF92ZXJzaW9uGAYgASgDEiAKGG1hcHBpbmdfcmVhZGluZXNzX3Njb3BlZBgHIAEoCCKpAQoaU3RhcnRRdWlja0ZpbGxBcHBseVJlcXVlc3QSSAoTZmFtaWx5X3R5cGVfdXBkYXRlcxgBIAMoCzIrLnBpcGVleC5mYW1pbHkudjEuRmFtaWx5VHlwZVBhcmFtZXRlclVwZGF0ZRJBCg9lbGVtZW50X3VwZGF0ZXMYAiADKAsyKC5waXBlZXguZmFtaWx5LnYxLkVsZW1lbnRQYXJhbWV0ZXJVcGRhdGUiygEKFFF1aWNrRmlsbEFwcGx5UmVzdWx0ElAKEmZhbWlseV90eXBlX3Jlc3VsdBgBIAEoCzI0LnBpcGVleC5mYW1pbHkudjEuVXBkYXRlRmFtaWx5VHlwZVBhcmFtZXRlcnNSZXNwb25zZRJJCg5lbGVtZW50X3Jlc3VsdBgCIAEoCzIxLnBpcGVleC5mYW1pbHkudjEuVXBkYXRlRWxlbWVudFBhcmFtZXRlcnNSZXNwb25zZRIVCg1tb2RlbF92ZXJzaW9uGAMgASgDKqoBCg9QYXJhbWV0ZXJTb3VyY2USIAocUEFSQU1FVEVSX1NPVVJDRV9VTlNQRUNJRklFRBAAEhsKF1BBUkFNRVRFUl9TT1VSQ0VfU0hBUkVEEAESHAoYUEFSQU1FVEVSX1NPVVJDRV9QUk9KRUNUEAISGwoXUEFSQU1FVEVSX1NPVVJDRV9GQU1JTFkQAxIdChlQQVJBTUVURVJfU09VUkNFX0JVSUxUX0lOEAQqmwEKFlF1aWNrRmlsbFNuYXBzaG90U2hhcGUSKQolUVVJQ0tfRklMTF9TTkFQU0hPVF9TSEFQRV9VTlNQRUNJRklFRBAAEikKJVFVSUNLX0ZJTExfU05BUFNIT1RfU0hBUEVfRkFNSUxZX1RZUEUQARIrCidRVUlDS19GSUxMX1NOQVBTSE9UX1NIQVBFX0lOU1RBTkNFX09OTFkQAjLFEwoNRmFtaWx5U2VydmljZRKEAQoZR2V0RmFtaWxpZXNXaXRoUGFyYW1ldGVycxIyLnBpcGVleC5mYW1pbHkudjEuR2V0RmFtaWxpZXNXaXRoUGFyYW1ldGVyc1JlcXVlc3QaMy5waXBlZXguZmFtaWx5LnYxLkdldEZhbWlsaWVzV2l0aFBhcmFtZXRlcnNSZXNwb25zZRJ9Ch5TdGFydEdldEZhbWlsaWVzV2l0aFBhcmFtZXRlcnMSMi5waXBlZXguZmFtaWx5LnYxLkdldEZhbWlsaWVzV2l0aFBhcmFtZXRlcnNSZXF1ZXN0GicucGlwZWV4LnJldml0LnYxLlN0YXJ0T3BlcmF0aW9uUmVzcG9uc2USewoWR2V0QXZhaWxhYmxlUGFyYW1ldGVycxIvLnBpcGVleC5mYW1pbHkudjEuR2V0QXZhaWxhYmxlUGFyYW1ldGVyc1JlcXVlc3QaMC5waXBlZXguZmFtaWx5LnYxLkdldEF2YWlsYWJsZVBhcmFtZXRlcnNSZXNwb25zZRJ3ChtTdGFydEdldEF2YWlsYWJsZVBhcmFtZXRlcnMSLy5waXBlZXguZmFtaWx5LnYxLkdldEF2YWlsYWJsZVBhcmFtZXRlcnNSZXF1ZXN0GicucGlwZWV4LnJldml0LnYxLlN0YXJ0T3BlcmF0aW9uUmVzcG9uc2UShAEKGVVwZGF0ZUZhbWlseVR5cGVQYXJhbWV0ZXISMi5waXBlZXguZmFtaWx5LnYxLlVwZGF0ZUZhbWlseVR5cGVQYXJhbWV0ZXJSZXF1ZXN0GjMucGlwZWV4LmZhbWlseS52MS5VcGRhdGVGYW1pbHlUeXBlUGFyYW1ldGVyUmVzcG9uc2UShwEKGlVwZGF0ZUZhbWlseVR5cGVQYXJhbWV0ZXJzEjMucGlwZWV4LmZhbWlseS52MS5VcGRhdGVGYW1pbHlUeXBlUGFyYW1ldGVyc1JlcXVlc3QaNC5waXBlZXguZmFtaWx5LnYxLlVwZGF0ZUZhbWlseVR5cGVQYXJhbWV0ZXJzUmVzcG9uc2USfwofU3RhcnRVcGRhdGVGYW1pbHlUeXBlUGFyYW1ldGVycxIzLnBpcGVleC5mYW1pbHkudjEuVXBkYXRlRmFtaWx5VHlwZVBhcmFtZXRlcnNSZXF1ZXN0GicucGlwZWV4LnJldml0LnYxLlN0YXJ0T3BlcmF0aW9uUmVzcG9uc2USfgoXVXBkYXRlRWxlbWVudFBhcmFtZXRlcnMSMC5waXBlZXguZmFtaWx5LnYxLlVwZGF0ZUVsZW1lbnRQYXJhbWV0ZXJzUmVxdWVzdBoxLnBpcGVleC5mYW1pbHkudjEuVXBkYXRlRWxlbWVudFBhcmFtZXRlcnNSZXNwb25zZRJ5ChxTdGFydFVwZGF0ZUVsZW1lbnRQYXJhbWV0ZXJzEjAucGlwZWV4LmZhbWlseS52MS5VcGRhdGVFbGVtZW50UGFyYW1ldGVyc1JlcXVlc3QaJy5waXBlZXgucmV2aXQudjEuU3RhcnRPcGVyYXRpb25SZXNwb25zZRJ4ChVMb2FkRmFtaWx5SW50b1Byb2plY3QSLi5waXBlZXguZmFtaWx5LnYxLkxvYWRGYW1pbHlJbnRvUHJvamVjdFJlcXVlc3QaLy5waXBlZXguZmFtaWx5LnYxLkxvYWRGYW1pbHlJbnRvUHJvamVjdFJlc3BvbnNlEnUKGlN0YXJ0TG9hZEZhbWlseUludG9Qcm9qZWN0Ei4ucGlwZWV4LmZhbWlseS52MS5Mb2FkRmFtaWx5SW50b1Byb2plY3RSZXF1ZXN0GicucGlwZWV4LnJldml0LnYxLlN0YXJ0T3BlcmF0aW9uUmVzcG9uc2USlgEKH0FkZFBhcmFtZXRlcnNUb1NwZWNpZmljRmFtaWxpZXMSOC5waXBlZXguZmFtaWx5LnYxLkFkZFBhcmFtZXRlcnNUb1NwZWNpZmljRmFtaWxpZXNSZXF1ZXN0GjkucGlwZWV4LmZhbWlseS52MS5BZGRQYXJhbWV0ZXJzVG9TcGVjaWZpY0ZhbWlsaWVzUmVzcG9uc2USiQEKJFN0YXJ0QWRkUGFyYW1ldGVyc1RvU3BlY2lmaWNGYW1pbGllcxI4LnBpcGVleC5mYW1pbHkudjEuQWRkUGFyYW1ldGVyc1RvU3BlY2lmaWNGYW1pbGllc1JlcXVlc3QaJy5waXBlZXgucmV2aXQudjEuU3RhcnRPcGVyYXRpb25SZXNwb25zZRKoAQolVW5kb0FkZGVkUGFyYW1ldGVyc1RvU3BlY2lmaWNGYW1pbGllcxI+LnBpcGVleC5mYW1pbHkudjEuVW5kb0FkZGVkUGFyYW1ldGVyc1RvU3BlY2lmaWNGYW1pbGllc1JlcXVlc3QaPy5waXBlZXguZmFtaWx5LnYxLlVuZG9BZGRlZFBhcmFtZXRlcnNUb1NwZWNpZmljRmFtaWxpZXNSZXNwb25zZRKVAQoqU3RhcnRVbmRvQWRkZWRQYXJhbWV0ZXJzVG9TcGVjaWZpY0ZhbWlsaWVzEj4ucGlwZWV4LmZhbWlseS52MS5VbmRvQWRkZWRQYXJhbWV0ZXJzVG9TcGVjaWZpY0ZhbWlsaWVzUmVxdWVzdBonLnBpcGVleC5yZXZpdC52MS5TdGFydE9wZXJhdGlvblJlc3BvbnNlEmkKEEdldFF1aWNrRmlsbERhdGESKS5waXBlZXguZmFtaWx5LnYxLkdldFF1aWNrRmlsbERhdGFSZXF1ZXN0GioucGlwZWV4LmZhbWlseS52MS5HZXRRdWlja0ZpbGxEYXRhUmVzcG9uc2USaAoSU3RhcnRRdWlja0ZpbGxMb2FkEikucGlwZWV4LmZhbWlseS52MS5HZXRRdWlja0ZpbGxEYXRhUmVxdWVzdBonLnBpcGVleC5yZXZpdC52MS5TdGFydE9wZXJhdGlvblJlc3BvbnNlEmwKE1N0YXJ0UXVpY2tGaWxsQXBwbHkSLC5waXBlZXguZmFtaWx5LnYxLlN0YXJ0UXVpY2tGaWxsQXBwbHlSZXF1ZXN0GicucGlwZWV4LnJldml0LnYxLlN0YXJ0T3BlcmF0aW9uUmVzcG9uc2USjgEKH0Fzc2Vzc01hcHBpbmdGYW1pbHlSZXF1aXJlbWVudHMSNC5waXBlZXguZmFtaWx5LnYxLkZhbWlseVJlcXVpcmVtZW50QXNzZXNzbWVudFJlcXVlc3QaNS5waXBlZXguZmFtaWx5LnYxLkZhbWlseVJlcXVpcmVtZW50QXNzZXNzbWVudFJlc3BvbnNlQhCqAg1QaXBlZVguUHJvdG9zYgZwcm90bzM", [file_revit_service, file_parameter_undo]);

/**
 * @generated from message pipeex.family.v1.GetFamiliesWithParametersRequest
 */
export type GetFamiliesWithParametersRequest = Message<"pipeex.family.v1.GetFamiliesWithParametersRequest"> & {
  /**
   * Optional list of parameter names to fetch.
   * Empty = return ALL parameters.
   *
   * @generated from field: repeated string parameter_names = 1;
   */
  parameterNames: string[];

  /**
   * Optional family ids for a definition-level inspection. Scoped reads avoid
   * walking project instances and can open only the requested family documents
   * to expose unplaced instance-bound family parameters.
   *
   * @generated from field: repeated string scoped_family_ids = 2;
   */
  scopedFamilyIds: string[];

  /**
   * Optional routing hints for requested names. Blank, unknown, or conflicting
   * values retain the broad legacy lookup driven by parameter_names.
   *
   * @generated from field: repeated pipeex.family.v1.RequestedParameterIntent requested_parameters = 3;
   */
  requestedParameters: RequestedParameterIntent[];
};

/**
 * Describes the message pipeex.family.v1.GetFamiliesWithParametersRequest.
 * Use `create(GetFamiliesWithParametersRequestSchema)` to create a new message.
 */
export const GetFamiliesWithParametersRequestSchema: GenMessage<GetFamiliesWithParametersRequest> = /*@__PURE__*/
  messageDesc(file_family_service, 0);

/**
 * @generated from message pipeex.family.v1.RequestedParameterIntent
 */
export type RequestedParameterIntent = Message<"pipeex.family.v1.RequestedParameterIntent"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * "project" or "family" (case-insensitive).
   *
   * @generated from field: string destination = 2;
   */
  destination: string;

  /**
   * "type" or "instance" (case-insensitive).
   *
   * @generated from field: string binding_kind = 3;
   */
  bindingKind: string;
};

/**
 * Describes the message pipeex.family.v1.RequestedParameterIntent.
 * Use `create(RequestedParameterIntentSchema)` to create a new message.
 */
export const RequestedParameterIntentSchema: GenMessage<RequestedParameterIntent> = /*@__PURE__*/
  messageDesc(file_family_service, 1);

/**
 * @generated from message pipeex.family.v1.FamilyScopeRequirementInput
 */
export type FamilyScopeRequirementInput = Message<"pipeex.family.v1.FamilyScopeRequirementInput"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string parameter_name = 2;
   */
  parameterName: string;

  /**
   * "project" or "family" (case-insensitive).
   *
   * @generated from field: string destination = 3;
   */
  destination: string;

  /**
   * "type" or "instance" (case-insensitive).
   *
   * @generated from field: string binding_kind = 4;
   */
  bindingKind: string;

  /**
   * "editableFamilyCategories" or "familyObjectTypes".
   *
   * @generated from field: string target_kind = 5;
   */
  targetKind: string;

  /**
   * editableFamilyCategories target categories (canonical English names).
   *
   * @generated from field: repeated string categories = 6;
   */
  categories: string[];

  /**
   * familyObjectTypes target object-type values.
   *
   * @generated from field: repeated string object_types = 7;
   */
  objectTypes: string[];

  /**
   * @generated from field: string discriminator_parameter_name = 8;
   */
  discriminatorParameterName: string;

  /**
   * "project" or "family" (case-insensitive).
   *
   * @generated from field: string discriminator_destination = 9;
   */
  discriminatorDestination: string;

  /**
   * "type" or "instance" (case-insensitive).
   *
   * @generated from field: string discriminator_binding_kind = 10;
   */
  discriminatorBindingKind: string;

  /**
   * "required" or "non-applicable".
   *
   * @generated from field: string empty_match_policy = 11;
   */
  emptyMatchPolicy: string;

  /**
   * Optional expected data type token (e.g. TEXT, INTEGER); empty = any.
   *
   * @generated from field: string data_type_hint = 12;
   */
  dataTypeHint: string;
};

/**
 * Describes the message pipeex.family.v1.FamilyScopeRequirementInput.
 * Use `create(FamilyScopeRequirementInputSchema)` to create a new message.
 */
export const FamilyScopeRequirementInputSchema: GenMessage<FamilyScopeRequirementInput> = /*@__PURE__*/
  messageDesc(file_family_service, 2);

/**
 * @generated from message pipeex.family.v1.FamilyRequirementAssessmentRequest
 */
export type FamilyRequirementAssessmentRequest = Message<"pipeex.family.v1.FamilyRequirementAssessmentRequest"> & {
  /**
   * @generated from field: repeated pipeex.family.v1.FamilyScopeRequirementInput requirements = 1;
   */
  requirements: FamilyScopeRequirementInput[];
};

/**
 * Describes the message pipeex.family.v1.FamilyRequirementAssessmentRequest.
 * Use `create(FamilyRequirementAssessmentRequestSchema)` to create a new message.
 */
export const FamilyRequirementAssessmentRequestSchema: GenMessage<FamilyRequirementAssessmentRequest> = /*@__PURE__*/
  messageDesc(file_family_service, 3);

/**
 * @generated from message pipeex.family.v1.FamilyScopeConflictDto
 */
export type FamilyScopeConflictDto = Message<"pipeex.family.v1.FamilyScopeConflictDto"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string entity_name = 2;
   */
  entityName: string;

  /**
   * "type" or "instance".
   *
   * @generated from field: string actual_binding_kind = 3;
   */
  actualBindingKind: string;

  /**
   * "binding" or "dataType".
   *
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * Describes the message pipeex.family.v1.FamilyScopeConflictDto.
 * Use `create(FamilyScopeConflictDtoSchema)` to create a new message.
 */
export const FamilyScopeConflictDtoSchema: GenMessage<FamilyScopeConflictDto> = /*@__PURE__*/
  messageDesc(file_family_service, 4);

/**
 * @generated from message pipeex.family.v1.FamilyScopeAssessmentDto
 */
export type FamilyScopeAssessmentDto = Message<"pipeex.family.v1.FamilyScopeAssessmentDto"> & {
  /**
   * @generated from field: string requirement_key = 1;
   */
  requirementKey: string;

  /**
   * @generated from field: bool satisfied = 2;
   */
  satisfied: boolean;

  /**
   * "satisfied", "missing", "conflict" or "not-applicable".
   *
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: int32 matching_entity_count = 4;
   */
  matchingEntityCount: number;

  /**
   * @generated from field: repeated pipeex.family.v1.FamilyScopeConflictDto conflicts = 5;
   */
  conflicts: FamilyScopeConflictDto[];
};

/**
 * Describes the message pipeex.family.v1.FamilyScopeAssessmentDto.
 * Use `create(FamilyScopeAssessmentDtoSchema)` to create a new message.
 */
export const FamilyScopeAssessmentDtoSchema: GenMessage<FamilyScopeAssessmentDto> = /*@__PURE__*/
  messageDesc(file_family_service, 5);

/**
 * @generated from message pipeex.family.v1.FamilyRequirementAssessmentResponse
 */
export type FamilyRequirementAssessmentResponse = Message<"pipeex.family.v1.FamilyRequirementAssessmentResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: int64 model_version = 3;
   */
  modelVersion: bigint;

  /**
   * @generated from field: repeated pipeex.family.v1.FamilyScopeAssessmentDto assessments = 4;
   */
  assessments: FamilyScopeAssessmentDto[];
};

/**
 * Describes the message pipeex.family.v1.FamilyRequirementAssessmentResponse.
 * Use `create(FamilyRequirementAssessmentResponseSchema)` to create a new message.
 */
export const FamilyRequirementAssessmentResponseSchema: GenMessage<FamilyRequirementAssessmentResponse> = /*@__PURE__*/
  messageDesc(file_family_service, 6);

/**
 * @generated from message pipeex.family.v1.FamilyParameterValue
 */
export type FamilyParameterValue = Message<"pipeex.family.v1.FamilyParameterValue"> & {
  /**
   * @generated from field: string parameter_id = 1;
   */
  parameterId: string;

  /**
   * @generated from field: string parameter_name = 2;
   */
  parameterName: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * @generated from field: bool is_read_only = 4;
   */
  isReadOnly: boolean;

  /**
   * @generated from field: bool is_instance = 5;
   */
  isInstance: boolean;

  /**
   * @generated from field: string data_type = 6;
   */
  dataType: string;
};

/**
 * Describes the message pipeex.family.v1.FamilyParameterValue.
 * Use `create(FamilyParameterValueSchema)` to create a new message.
 */
export const FamilyParameterValueSchema: GenMessage<FamilyParameterValue> = /*@__PURE__*/
  messageDesc(file_family_service, 7);

/**
 * @generated from message pipeex.family.v1.FamilyTypeDto
 */
export type FamilyTypeDto = Message<"pipeex.family.v1.FamilyTypeDto"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated pipeex.family.v1.FamilyParameterValue parameter_values = 3;
   */
  parameterValues: FamilyParameterValue[];
};

/**
 * Describes the message pipeex.family.v1.FamilyTypeDto.
 * Use `create(FamilyTypeDtoSchema)` to create a new message.
 */
export const FamilyTypeDtoSchema: GenMessage<FamilyTypeDto> = /*@__PURE__*/
  messageDesc(file_family_service, 8);

/**
 * @generated from message pipeex.family.v1.FamilyDto
 */
export type FamilyDto = Message<"pipeex.family.v1.FamilyDto"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * @generated from field: bool is_editable = 4;
   */
  isEditable: boolean;

  /**
   * @generated from field: bool is_system_family = 5;
   */
  isSystemFamily: boolean;

  /**
   * @generated from field: repeated pipeex.family.v1.FamilyTypeDto types = 6;
   */
  types: FamilyTypeDto[];
};

/**
 * Describes the message pipeex.family.v1.FamilyDto.
 * Use `create(FamilyDtoSchema)` to create a new message.
 */
export const FamilyDtoSchema: GenMessage<FamilyDto> = /*@__PURE__*/
  messageDesc(file_family_service, 9);

/**
 * @generated from message pipeex.family.v1.GetFamiliesWithParametersResponse
 */
export type GetFamiliesWithParametersResponse = Message<"pipeex.family.v1.GetFamiliesWithParametersResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: repeated pipeex.family.v1.FamilyDto families = 3;
   */
  families: FamilyDto[];
};

/**
 * Describes the message pipeex.family.v1.GetFamiliesWithParametersResponse.
 * Use `create(GetFamiliesWithParametersResponseSchema)` to create a new message.
 */
export const GetFamiliesWithParametersResponseSchema: GenMessage<GetFamiliesWithParametersResponse> = /*@__PURE__*/
  messageDesc(file_family_service, 10);

/**
 * @generated from message pipeex.family.v1.GetAvailableParametersRequest
 */
export type GetAvailableParametersRequest = Message<"pipeex.family.v1.GetAvailableParametersRequest"> & {
};

/**
 * Describes the message pipeex.family.v1.GetAvailableParametersRequest.
 * Use `create(GetAvailableParametersRequestSchema)` to create a new message.
 */
export const GetAvailableParametersRequestSchema: GenMessage<GetAvailableParametersRequest> = /*@__PURE__*/
  messageDesc(file_family_service, 11);

/**
 * @generated from message pipeex.family.v1.AvailableParameter
 */
export type AvailableParameter = Message<"pipeex.family.v1.AvailableParameter"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * "Type" or "Instance"
   *
   * @generated from field: string parameter_type = 3;
   */
  parameterType: string;

  /**
   * @generated from field: string group = 4;
   */
  group: string;

  /**
   * @generated from field: bool is_instance = 5;
   */
  isInstance: boolean;

  /**
   * Shared parameter file DATA token (TEXT, INTEGER, LENGTH, YESNO, ...); empty when unknown.
   *
   * @generated from field: string data_type = 6;
   */
  dataType: string;

  /**
   * @generated from field: bool is_project_binding = 7;
   */
  isProjectBinding: boolean;

  /**
   * @generated from field: repeated string categories = 8;
   */
  categories: string[];

  /**
   * Where the parameter definition was created; UNSPECIFIED on old hosts.
   *
   * @generated from field: pipeex.family.v1.ParameterSource source = 9;
   */
  source: ParameterSource;
};

/**
 * Describes the message pipeex.family.v1.AvailableParameter.
 * Use `create(AvailableParameterSchema)` to create a new message.
 */
export const AvailableParameterSchema: GenMessage<AvailableParameter> = /*@__PURE__*/
  messageDesc(file_family_service, 12);

/**
 * @generated from message pipeex.family.v1.GetAvailableParametersResponse
 */
export type GetAvailableParametersResponse = Message<"pipeex.family.v1.GetAvailableParametersResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: repeated pipeex.family.v1.AvailableParameter parameters = 3;
   */
  parameters: AvailableParameter[];
};

/**
 * Describes the message pipeex.family.v1.GetAvailableParametersResponse.
 * Use `create(GetAvailableParametersResponseSchema)` to create a new message.
 */
export const GetAvailableParametersResponseSchema: GenMessage<GetAvailableParametersResponse> = /*@__PURE__*/
  messageDesc(file_family_service, 13);

/**
 * @generated from message pipeex.family.v1.PipeElementDto
 */
export type PipeElementDto = Message<"pipeex.family.v1.PipeElementDto"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string family_name = 2;
   */
  familyName: string;

  /**
   * @generated from field: string type_name = 3;
   */
  typeName: string;

  /**
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * @generated from field: repeated pipeex.family.v1.FamilyParameterValue parameter_values = 5;
   */
  parameterValues: FamilyParameterValue[];

  /**
   * @generated from field: string element_name = 6;
   */
  elementName: string;

  /**
   * @generated from field: string type_id = 7;
   */
  typeId: string;
};

/**
 * Describes the message pipeex.family.v1.PipeElementDto.
 * Use `create(PipeElementDtoSchema)` to create a new message.
 */
export const PipeElementDtoSchema: GenMessage<PipeElementDto> = /*@__PURE__*/
  messageDesc(file_family_service, 14);

/**
 * @generated from message pipeex.family.v1.UpdateFamilyTypeParameterRequest
 */
export type UpdateFamilyTypeParameterRequest = Message<"pipeex.family.v1.UpdateFamilyTypeParameterRequest"> & {
  /**
   * Format: "FamilyName:TypeName" e.g. "Cross - Generic:Standard"
   *
   * @generated from field: string family_type_name = 1;
   */
  familyTypeName: string;

  /**
   * @generated from field: string parameter_name = 2;
   */
  parameterName: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message pipeex.family.v1.UpdateFamilyTypeParameterRequest.
 * Use `create(UpdateFamilyTypeParameterRequestSchema)` to create a new message.
 */
export const UpdateFamilyTypeParameterRequestSchema: GenMessage<UpdateFamilyTypeParameterRequest> = /*@__PURE__*/
  messageDesc(file_family_service, 15);

/**
 * @generated from message pipeex.family.v1.UpdateFamilyTypeParameterResponse
 */
export type UpdateFamilyTypeParameterResponse = Message<"pipeex.family.v1.UpdateFamilyTypeParameterResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: string family_type = 3;
   */
  familyType: string;

  /**
   * @generated from field: string parameter = 4;
   */
  parameter: string;

  /**
   * @generated from field: string new_value = 5;
   */
  newValue: string;
};

/**
 * Describes the message pipeex.family.v1.UpdateFamilyTypeParameterResponse.
 * Use `create(UpdateFamilyTypeParameterResponseSchema)` to create a new message.
 */
export const UpdateFamilyTypeParameterResponseSchema: GenMessage<UpdateFamilyTypeParameterResponse> = /*@__PURE__*/
  messageDesc(file_family_service, 16);

/**
 * @generated from message pipeex.family.v1.FamilyTypeParameterUpdate
 */
export type FamilyTypeParameterUpdate = Message<"pipeex.family.v1.FamilyTypeParameterUpdate"> & {
  /**
   * @generated from field: string family_type = 1;
   */
  familyType: string;

  /**
   * @generated from field: string parameter_name = 2;
   */
  parameterName: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * @generated from field: string family_type_id = 4;
   */
  familyTypeId: string;

  /**
   * @generated from field: repeated string target_element_ids = 5;
   */
  targetElementIds: string[];

  /**
   * Optional routing hint. "type" and "instance" are matched case-insensitively;
   * blank or unknown values preserve the legacy broad resolver.
   *
   * @generated from field: string binding_kind = 6;
   */
  bindingKind: string;
};

/**
 * Describes the message pipeex.family.v1.FamilyTypeParameterUpdate.
 * Use `create(FamilyTypeParameterUpdateSchema)` to create a new message.
 */
export const FamilyTypeParameterUpdateSchema: GenMessage<FamilyTypeParameterUpdate> = /*@__PURE__*/
  messageDesc(file_family_service, 17);

/**
 * @generated from message pipeex.family.v1.UpdateFamilyTypeParametersRequest
 */
export type UpdateFamilyTypeParametersRequest = Message<"pipeex.family.v1.UpdateFamilyTypeParametersRequest"> & {
  /**
   * @generated from field: repeated pipeex.family.v1.FamilyTypeParameterUpdate updates = 1;
   */
  updates: FamilyTypeParameterUpdate[];
};

/**
 * Describes the message pipeex.family.v1.UpdateFamilyTypeParametersRequest.
 * Use `create(UpdateFamilyTypeParametersRequestSchema)` to create a new message.
 */
export const UpdateFamilyTypeParametersRequestSchema: GenMessage<UpdateFamilyTypeParametersRequest> = /*@__PURE__*/
  messageDesc(file_family_service, 18);

/**
 * @generated from message pipeex.family.v1.UpdateFamilyTypeParametersResponse
 */
export type UpdateFamilyTypeParametersResponse = Message<"pipeex.family.v1.UpdateFamilyTypeParametersResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: int32 total_updates = 3;
   */
  totalUpdates: number;

  /**
   * @generated from field: int32 success_count = 4;
   */
  successCount: number;

  /**
   * @generated from field: int32 error_count = 5;
   */
  errorCount: number;

  /**
   * @generated from field: repeated string errors = 6;
   */
  errors: string[];
};

/**
 * Describes the message pipeex.family.v1.UpdateFamilyTypeParametersResponse.
 * Use `create(UpdateFamilyTypeParametersResponseSchema)` to create a new message.
 */
export const UpdateFamilyTypeParametersResponseSchema: GenMessage<UpdateFamilyTypeParametersResponse> = /*@__PURE__*/
  messageDesc(file_family_service, 19);

/**
 * @generated from message pipeex.family.v1.ElementParameterUpdate
 */
export type ElementParameterUpdate = Message<"pipeex.family.v1.ElementParameterUpdate"> & {
  /**
   * @generated from field: string element_id = 1;
   */
  elementId: string;

  /**
   * @generated from field: string parameter_name = 2;
   */
  parameterName: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message pipeex.family.v1.ElementParameterUpdate.
 * Use `create(ElementParameterUpdateSchema)` to create a new message.
 */
export const ElementParameterUpdateSchema: GenMessage<ElementParameterUpdate> = /*@__PURE__*/
  messageDesc(file_family_service, 20);

/**
 * @generated from message pipeex.family.v1.UpdateElementParametersRequest
 */
export type UpdateElementParametersRequest = Message<"pipeex.family.v1.UpdateElementParametersRequest"> & {
  /**
   * @generated from field: repeated pipeex.family.v1.ElementParameterUpdate updates = 1;
   */
  updates: ElementParameterUpdate[];
};

/**
 * Describes the message pipeex.family.v1.UpdateElementParametersRequest.
 * Use `create(UpdateElementParametersRequestSchema)` to create a new message.
 */
export const UpdateElementParametersRequestSchema: GenMessage<UpdateElementParametersRequest> = /*@__PURE__*/
  messageDesc(file_family_service, 21);

/**
 * @generated from message pipeex.family.v1.UpdateElementParametersResponse
 */
export type UpdateElementParametersResponse = Message<"pipeex.family.v1.UpdateElementParametersResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: int32 total_updates = 3;
   */
  totalUpdates: number;

  /**
   * @generated from field: int32 success_count = 4;
   */
  successCount: number;

  /**
   * @generated from field: int32 error_count = 5;
   */
  errorCount: number;

  /**
   * @generated from field: repeated string errors = 6;
   */
  errors: string[];
};

/**
 * Describes the message pipeex.family.v1.UpdateElementParametersResponse.
 * Use `create(UpdateElementParametersResponseSchema)` to create a new message.
 */
export const UpdateElementParametersResponseSchema: GenMessage<UpdateElementParametersResponse> = /*@__PURE__*/
  messageDesc(file_family_service, 22);

/**
 * @generated from message pipeex.family.v1.LoadFamilyIntoProjectRequest
 */
export type LoadFamilyIntoProjectRequest = Message<"pipeex.family.v1.LoadFamilyIntoProjectRequest"> & {
  /**
   * Full path to the .rfa family file
   *
   * @generated from field: string family_file_path = 1;
   */
  familyFilePath: string;
};

/**
 * Describes the message pipeex.family.v1.LoadFamilyIntoProjectRequest.
 * Use `create(LoadFamilyIntoProjectRequestSchema)` to create a new message.
 */
export const LoadFamilyIntoProjectRequestSchema: GenMessage<LoadFamilyIntoProjectRequest> = /*@__PURE__*/
  messageDesc(file_family_service, 23);

/**
 * @generated from message pipeex.family.v1.LoadFamilyIntoProjectResponse
 */
export type LoadFamilyIntoProjectResponse = Message<"pipeex.family.v1.LoadFamilyIntoProjectResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: string family_id = 3;
   */
  familyId: string;

  /**
   * @generated from field: string family_name = 4;
   */
  familyName: string;

  /**
   * @generated from field: string category = 5;
   */
  category: string;

  /**
   * @generated from field: int32 types_count = 6;
   */
  typesCount: number;

  /**
   * @generated from field: string message = 7;
   */
  message: string;
};

/**
 * Describes the message pipeex.family.v1.LoadFamilyIntoProjectResponse.
 * Use `create(LoadFamilyIntoProjectResponseSchema)` to create a new message.
 */
export const LoadFamilyIntoProjectResponseSchema: GenMessage<LoadFamilyIntoProjectResponse> = /*@__PURE__*/
  messageDesc(file_family_service, 24);

/**
 * @generated from message pipeex.family.v1.AddParametersToSpecificFamiliesRequest
 */
export type AddParametersToSpecificFamiliesRequest = Message<"pipeex.family.v1.AddParametersToSpecificFamiliesRequest"> & {
  /**
   * @generated from field: repeated string family_ids = 1;
   */
  familyIds: string[];

  /**
   * @generated from field: repeated string parameter_names = 2;
   */
  parameterNames: string[];

  /**
   * @generated from field: bool include_system_families = 3;
   */
  includeSystemFamilies: boolean;

  /**
   * Optional overrides
   *
   * @generated from field: repeated string categories = 4;
   */
  categories: string[];

  /**
   * @generated from field: string shared_parameter_file_path = 5;
   */
  sharedParameterFilePath: string;

  /**
   * @generated from field: string shared_parameter_file_content = 6;
   */
  sharedParameterFileContent: string;

  /**
   * @generated from field: string binding_kind = 7;
   */
  bindingKind: string;

  /**
   * @generated from field: repeated string target_object_types = 8;
   */
  targetObjectTypes: string[];

  /**
   * @generated from field: string expected_document_name = 9;
   */
  expectedDocumentName: string;

  /**
   * @generated from field: string expected_document_path = 10;
   */
  expectedDocumentPath: string;

  /**
   * Data type hints (shared parameter file DATA tokens) used when a
   * requested parameter is missing from the shared parameter file and must
   * be created ad-hoc.
   *
   * @generated from field: repeated pipeex.revit.v1.ParameterDataTypeHint parameter_type_hints = 11;
   */
  parameterTypeHints: ParameterDataTypeHint[];

  /**
   * Current wizard/profile parameter used to classify placed family instances.
   *
   * @generated from field: string object_type_parameter_name = 12;
   */
  objectTypeParameterName: string;

  /**
   * Connector target changes must remain compensatable. When true, an
   * incompatible existing definition is reported as a conflict instead of
   * being destructively replaced with loss of its old values.
   *
   * @generated from field: bool require_reversible_mutations = 13;
   */
  requireReversibleMutations: boolean;
};

/**
 * Describes the message pipeex.family.v1.AddParametersToSpecificFamiliesRequest.
 * Use `create(AddParametersToSpecificFamiliesRequestSchema)` to create a new message.
 */
export const AddParametersToSpecificFamiliesRequestSchema: GenMessage<AddParametersToSpecificFamiliesRequest> = /*@__PURE__*/
  messageDesc(file_family_service, 25);

/**
 * @generated from message pipeex.family.v1.ModifiedFamilyResult
 */
export type ModifiedFamilyResult = Message<"pipeex.family.v1.ModifiedFamilyResult"> & {
  /**
   * @generated from field: string family_name = 1;
   */
  familyName: string;

  /**
   * @generated from field: string family_id = 2;
   */
  familyId: string;

  /**
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * @generated from field: repeated string added_parameters = 4;
   */
  addedParameters: string[];
};

/**
 * Describes the message pipeex.family.v1.ModifiedFamilyResult.
 * Use `create(ModifiedFamilyResultSchema)` to create a new message.
 */
export const ModifiedFamilyResultSchema: GenMessage<ModifiedFamilyResult> = /*@__PURE__*/
  messageDesc(file_family_service, 26);

/**
 * @generated from message pipeex.family.v1.AddParametersToSpecificFamiliesResponse
 */
export type AddParametersToSpecificFamiliesResponse = Message<"pipeex.family.v1.AddParametersToSpecificFamiliesResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: int32 modified_families_count = 3;
   */
  modifiedFamiliesCount: number;

  /**
   * @generated from field: int32 system_family_params_added = 4;
   */
  systemFamilyParamsAdded: number;

  /**
   * @generated from field: repeated pipeex.family.v1.ModifiedFamilyResult modified_families = 5;
   */
  modifiedFamilies: ModifiedFamilyResult[];

  /**
   * @generated from field: string message = 6;
   */
  message: string;

  /**
   * @generated from field: int32 resolved_family_target_count = 7;
   */
  resolvedFamilyTargetCount: number;

  /**
   * @generated from field: int32 processed_family_target_count = 8;
   */
  processedFamilyTargetCount: number;

  /**
   * @generated from field: int32 opened_family_count = 9;
   */
  openedFamilyCount: number;

  /**
   * @generated from field: int32 unmodified_family_target_count = 10;
   */
  unmodifiedFamilyTargetCount: number;

  /**
   * @generated from field: int32 existing_family_parameter_count = 11;
   */
  existingFamilyParameterCount: number;

  /**
   * @generated from field: int32 conflict_count = 12;
   */
  conflictCount: number;

  /**
   * @generated from field: int32 failure_count = 13;
   */
  failureCount: number;

  /**
   * Captured from the family documents that were actually committed/reloaded.
   *
   * @generated from field: repeated pipeex.family.v1.UndoAddedFamilyParameterEntry undo_entries = 14;
   */
  undoEntries: UndoAddedFamilyParameterEntry[];

  /**
   * System-family project bindings changed by this same operation, if any.
   *
   * @generated from field: repeated pipeex.parameterundo.v1.ProjectParameterUndoEntry project_undo_entries = 15;
   */
  projectUndoEntries: ProjectParameterUndoEntry[];
};

/**
 * Describes the message pipeex.family.v1.AddParametersToSpecificFamiliesResponse.
 * Use `create(AddParametersToSpecificFamiliesResponseSchema)` to create a new message.
 */
export const AddParametersToSpecificFamiliesResponseSchema: GenMessage<AddParametersToSpecificFamiliesResponse> = /*@__PURE__*/
  messageDesc(file_family_service, 27);

/**
 * @generated from message pipeex.family.v1.UndoAddedFamilyParameterEntry
 */
export type UndoAddedFamilyParameterEntry = Message<"pipeex.family.v1.UndoAddedFamilyParameterEntry"> & {
  /**
   * @generated from field: string family_id = 1;
   */
  familyId: string;

  /**
   * @generated from field: string family_name = 2;
   */
  familyName: string;

  /**
   * @generated from field: string parameter_name = 3;
   */
  parameterName: string;

  /**
   * @generated from field: bool existed_before = 4;
   */
  existedBefore: boolean;

  /**
   * @generated from field: string previous_binding_kind = 5;
   */
  previousBindingKind: string;
};

/**
 * Describes the message pipeex.family.v1.UndoAddedFamilyParameterEntry.
 * Use `create(UndoAddedFamilyParameterEntrySchema)` to create a new message.
 */
export const UndoAddedFamilyParameterEntrySchema: GenMessage<UndoAddedFamilyParameterEntry> = /*@__PURE__*/
  messageDesc(file_family_service, 28);

/**
 * @generated from message pipeex.family.v1.UndoAddedParametersToSpecificFamiliesRequest
 */
export type UndoAddedParametersToSpecificFamiliesRequest = Message<"pipeex.family.v1.UndoAddedParametersToSpecificFamiliesRequest"> & {
  /**
   * @generated from field: repeated pipeex.family.v1.UndoAddedFamilyParameterEntry entries = 1;
   */
  entries: UndoAddedFamilyParameterEntry[];

  /**
   * @generated from field: string expected_document_name = 2;
   */
  expectedDocumentName: string;

  /**
   * @generated from field: string expected_document_path = 3;
   */
  expectedDocumentPath: string;
};

/**
 * Describes the message pipeex.family.v1.UndoAddedParametersToSpecificFamiliesRequest.
 * Use `create(UndoAddedParametersToSpecificFamiliesRequestSchema)` to create a new message.
 */
export const UndoAddedParametersToSpecificFamiliesRequestSchema: GenMessage<UndoAddedParametersToSpecificFamiliesRequest> = /*@__PURE__*/
  messageDesc(file_family_service, 29);

/**
 * @generated from message pipeex.family.v1.UndoAddedParametersToSpecificFamiliesResponse
 */
export type UndoAddedParametersToSpecificFamiliesResponse = Message<"pipeex.family.v1.UndoAddedParametersToSpecificFamiliesResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: int32 undone_families_count = 3;
   */
  undoneFamiliesCount: number;

  /**
   * @generated from field: int32 removed_parameter_count = 4;
   */
  removedParameterCount: number;

  /**
   * @generated from field: int32 restored_parameter_count = 5;
   */
  restoredParameterCount: number;

  /**
   * @generated from field: repeated string errors = 6;
   */
  errors: string[];

  /**
   * @generated from field: string message = 7;
   */
  message: string;
};

/**
 * Describes the message pipeex.family.v1.UndoAddedParametersToSpecificFamiliesResponse.
 * Use `create(UndoAddedParametersToSpecificFamiliesResponseSchema)` to create a new message.
 */
export const UndoAddedParametersToSpecificFamiliesResponseSchema: GenMessage<UndoAddedParametersToSpecificFamiliesResponse> = /*@__PURE__*/
  messageDesc(file_family_service, 30);

/**
 * @generated from message pipeex.family.v1.GetQuickFillDataRequest
 */
export type GetQuickFillDataRequest = Message<"pipeex.family.v1.GetQuickFillDataRequest"> & {
  /**
   * Optional list of parameter names to fetch for families.
   * Empty = return ALL parameters.
   *
   * @generated from field: repeated string parameter_names = 1;
   */
  parameterNames: string[];

  /**
   * Controls the amount of model data collected for QuickFill.
   * UNSPECIFIED/FAMILY_TYPE keeps the existing family/type + instance metadata shape.
   * INSTANCE_ONLY skips family/type collection and returns project element instance rows.
   *
   * @generated from field: pipeex.family.v1.QuickFillSnapshotShape snapshot_shape = 2;
   */
  snapshotShape: QuickFillSnapshotShape;

  /**
   * Optional scope from validation or the parameter wizard.
   * Empty scope = full project snapshot.
   *
   * @generated from field: repeated string scoped_family_ids = 3;
   */
  scopedFamilyIds: string[];

  /**
   * @generated from field: repeated string scoped_family_names = 4;
   */
  scopedFamilyNames: string[];

  /**
   * @generated from field: repeated string scoped_family_type_keys = 5;
   */
  scopedFamilyTypeKeys: string[];

  /**
   * @generated from field: repeated string scoped_element_ids = 6;
   */
  scopedElementIds: string[];

  /**
   * @generated from field: repeated string scoped_category_names = 7;
   */
  scopedCategoryNames: string[];

  /**
   * When true, the startup snapshot skips opening unplaced family documents.
   * GetAvailableParameters remains the complete on-demand catalog.
   *
   * @generated from field: bool defer_unplaced_family_catalog = 8;
   */
  deferUnplacedFamilyCatalog: boolean;

  /**
   * Optional routing hints for requested names. Legacy parameter_names remain
   * supported and are used broadly whenever an intent is incomplete or unsafe.
   *
   * @generated from field: repeated pipeex.family.v1.RequestedParameterIntent requested_parameters = 9;
   */
  requestedParameters: RequestedParameterIntent[];

  /**
   * Mapping readiness requests only the named project bindings and family
   * definitions. It never walks project component instances and leaves the
   * legacy Quick Fill snapshot behavior unchanged when omitted/false.
   *
   * @generated from field: bool mapping_readiness_only = 10;
   */
  mappingReadinessOnly: boolean;
};

/**
 * Describes the message pipeex.family.v1.GetQuickFillDataRequest.
 * Use `create(GetQuickFillDataRequestSchema)` to create a new message.
 */
export const GetQuickFillDataRequestSchema: GenMessage<GetQuickFillDataRequest> = /*@__PURE__*/
  messageDesc(file_family_service, 31);

/**
 * @generated from message pipeex.family.v1.GetQuickFillDataResponse
 */
export type GetQuickFillDataResponse = Message<"pipeex.family.v1.GetQuickFillDataResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: repeated pipeex.family.v1.FamilyDto families = 3;
   */
  families: FamilyDto[];

  /**
   * @generated from field: repeated pipeex.family.v1.AvailableParameter available_parameters = 4;
   */
  availableParameters: AvailableParameter[];

  /**
   * @generated from field: repeated pipeex.family.v1.PipeElementDto pipe_elements = 5;
   */
  pipeElements: PipeElementDto[];

  /**
   * Authoritative host model version used to build or retrieve this snapshot.
   *
   * @generated from field: int64 model_version = 6;
   */
  modelVersion: bigint;

  /**
   * True only when the connector honored mapping_readiness_only and omitted
   * project component enumeration. Older connectors leave this false.
   *
   * @generated from field: bool mapping_readiness_scoped = 7;
   */
  mappingReadinessScoped: boolean;
};

/**
 * Describes the message pipeex.family.v1.GetQuickFillDataResponse.
 * Use `create(GetQuickFillDataResponseSchema)` to create a new message.
 */
export const GetQuickFillDataResponseSchema: GenMessage<GetQuickFillDataResponse> = /*@__PURE__*/
  messageDesc(file_family_service, 32);

/**
 * @generated from message pipeex.family.v1.StartQuickFillApplyRequest
 */
export type StartQuickFillApplyRequest = Message<"pipeex.family.v1.StartQuickFillApplyRequest"> & {
  /**
   * @generated from field: repeated pipeex.family.v1.FamilyTypeParameterUpdate family_type_updates = 1;
   */
  familyTypeUpdates: FamilyTypeParameterUpdate[];

  /**
   * @generated from field: repeated pipeex.family.v1.ElementParameterUpdate element_updates = 2;
   */
  elementUpdates: ElementParameterUpdate[];
};

/**
 * Describes the message pipeex.family.v1.StartQuickFillApplyRequest.
 * Use `create(StartQuickFillApplyRequestSchema)` to create a new message.
 */
export const StartQuickFillApplyRequestSchema: GenMessage<StartQuickFillApplyRequest> = /*@__PURE__*/
  messageDesc(file_family_service, 33);

/**
 * @generated from message pipeex.family.v1.QuickFillApplyResult
 */
export type QuickFillApplyResult = Message<"pipeex.family.v1.QuickFillApplyResult"> & {
  /**
   * @generated from field: pipeex.family.v1.UpdateFamilyTypeParametersResponse family_type_result = 1;
   */
  familyTypeResult?: UpdateFamilyTypeParametersResponse | undefined;

  /**
   * @generated from field: pipeex.family.v1.UpdateElementParametersResponse element_result = 2;
   */
  elementResult?: UpdateElementParametersResponse | undefined;

  /**
   * Authoritative host model version after the apply result was finalized.
   *
   * @generated from field: int64 model_version = 3;
   */
  modelVersion: bigint;
};

/**
 * Describes the message pipeex.family.v1.QuickFillApplyResult.
 * Use `create(QuickFillApplyResultSchema)` to create a new message.
 */
export const QuickFillApplyResultSchema: GenMessage<QuickFillApplyResult> = /*@__PURE__*/
  messageDesc(file_family_service, 34);

/**
 * Origin of a parameter definition. A name can surface through several Revit
 * mechanisms (family definition, project binding, element observation), but a
 * row reports where the definition was created: shared-parameter-file
 * definitions win over project parameters, which win over family-local ones.
 * Built-in definitions are reported last.
 *
 * @generated from enum pipeex.family.v1.ParameterSource
 */
export enum ParameterSource {
  /**
   * @generated from enum value: PARAMETER_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PARAMETER_SOURCE_SHARED = 1;
   */
  SHARED = 1,

  /**
   * @generated from enum value: PARAMETER_SOURCE_PROJECT = 2;
   */
  PROJECT = 2,

  /**
   * @generated from enum value: PARAMETER_SOURCE_FAMILY = 3;
   */
  FAMILY = 3,

  /**
   * @generated from enum value: PARAMETER_SOURCE_BUILT_IN = 4;
   */
  BUILT_IN = 4,
}

/**
 * Describes the enum pipeex.family.v1.ParameterSource.
 */
export const ParameterSourceSchema: GenEnum<ParameterSource> = /*@__PURE__*/
  enumDesc(file_family_service, 0);

/**
 * @generated from enum pipeex.family.v1.QuickFillSnapshotShape
 */
export enum QuickFillSnapshotShape {
  /**
   * @generated from enum value: QUICK_FILL_SNAPSHOT_SHAPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: QUICK_FILL_SNAPSHOT_SHAPE_FAMILY_TYPE = 1;
   */
  FAMILY_TYPE = 1,

  /**
   * @generated from enum value: QUICK_FILL_SNAPSHOT_SHAPE_INSTANCE_ONLY = 2;
   */
  INSTANCE_ONLY = 2,
}

/**
 * Describes the enum pipeex.family.v1.QuickFillSnapshotShape.
 */
export const QuickFillSnapshotShapeSchema: GenEnum<QuickFillSnapshotShape> = /*@__PURE__*/
  enumDesc(file_family_service, 1);

/**
 * Family read/lookup operations.
 * Note: batch QuickFill updates (binding + value filling) live in
 * quick_fill_service.proto / QuickFillService.RunQuickFill.
 *
 * @generated from service pipeex.family.v1.FamilyService
 */
export const FamilyService: GenService<{
  /**
   * Get all families with their types and parameter values for the QuickFill table.
   * Optional: pass parameter names to fetch only specific parameters.
   *
   * @generated from rpc pipeex.family.v1.FamilyService.GetFamiliesWithParameters
   */
  getFamiliesWithParameters: {
    methodKind: "unary";
    input: typeof GetFamiliesWithParametersRequestSchema;
    output: typeof GetFamiliesWithParametersResponseSchema;
  },
  /**
   * Start family snapshot collection as a host operation with live progress.
   *
   * @generated from rpc pipeex.family.v1.FamilyService.StartGetFamiliesWithParameters
   */
  startGetFamiliesWithParameters: {
    methodKind: "unary";
    input: typeof GetFamiliesWithParametersRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Get all available parameters for pipe-related categories
   * (Pipes, Pipe Fittings, Pipe Accessories, Generic Models, Mechanical Equipment).
   *
   * @generated from rpc pipeex.family.v1.FamilyService.GetAvailableParameters
   */
  getAvailableParameters: {
    methodKind: "unary";
    input: typeof GetAvailableParametersRequestSchema;
    output: typeof GetAvailableParametersResponseSchema;
  },
  /**
   * Start available-parameter collection as a host operation with live progress.
   *
   * @generated from rpc pipeex.family.v1.FamilyService.StartGetAvailableParameters
   */
  startGetAvailableParameters: {
    methodKind: "unary";
    input: typeof GetAvailableParametersRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Update a single parameter value on a family type (used for inline cell edits).
   *
   * @generated from rpc pipeex.family.v1.FamilyService.UpdateFamilyTypeParameter
   */
  updateFamilyTypeParameter: {
    methodKind: "unary";
    input: typeof UpdateFamilyTypeParameterRequestSchema;
    output: typeof UpdateFamilyTypeParameterResponseSchema;
  },
  /**
   * Batch-update multiple parameter values across multiple family types (QuickFill save).
   *
   * @generated from rpc pipeex.family.v1.FamilyService.UpdateFamilyTypeParameters
   */
  updateFamilyTypeParameters: {
    methodKind: "unary";
    input: typeof UpdateFamilyTypeParametersRequestSchema;
    output: typeof UpdateFamilyTypeParametersResponseSchema;
  },
  /**
   * Start family type parameter updates as a host operation with live progress.
   *
   * @generated from rpc pipeex.family.v1.FamilyService.StartUpdateFamilyTypeParameters
   */
  startUpdateFamilyTypeParameters: {
    methodKind: "unary";
    input: typeof UpdateFamilyTypeParametersRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Batch-update multiple parameter values across explicit element instances.
   *
   * @generated from rpc pipeex.family.v1.FamilyService.UpdateElementParameters
   */
  updateElementParameters: {
    methodKind: "unary";
    input: typeof UpdateElementParametersRequestSchema;
    output: typeof UpdateElementParametersResponseSchema;
  },
  /**
   * Start element parameter updates as a host operation with live progress.
   *
   * @generated from rpc pipeex.family.v1.FamilyService.StartUpdateElementParameters
   */
  startUpdateElementParameters: {
    methodKind: "unary";
    input: typeof UpdateElementParametersRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Load a family file (.rfa) into the active Revit project.
   *
   * @generated from rpc pipeex.family.v1.FamilyService.LoadFamilyIntoProject
   */
  loadFamilyIntoProject: {
    methodKind: "unary";
    input: typeof LoadFamilyIntoProjectRequestSchema;
    output: typeof LoadFamilyIntoProjectResponseSchema;
  },
  /**
   * Start family loading as a host operation with live progress.
   *
   * @generated from rpc pipeex.family.v1.FamilyService.StartLoadFamilyIntoProject
   */
  startLoadFamilyIntoProject: {
    methodKind: "unary";
    input: typeof LoadFamilyIntoProjectRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Add parameters to specific families by their IDs.
   * Optionally includes project parameters for system families.
   *
   * @generated from rpc pipeex.family.v1.FamilyService.AddParametersToSpecificFamilies
   */
  addParametersToSpecificFamilies: {
    methodKind: "unary";
    input: typeof AddParametersToSpecificFamiliesRequestSchema;
    output: typeof AddParametersToSpecificFamiliesResponseSchema;
  },
  /**
   * Start family parameter setup as a host operation with live progress.
   *
   * @generated from rpc pipeex.family.v1.FamilyService.StartAddParametersToSpecificFamilies
   */
  startAddParametersToSpecificFamilies: {
    methodKind: "unary";
    input: typeof AddParametersToSpecificFamiliesRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Undo parameter additions performed on specific editable families.
   *
   * @generated from rpc pipeex.family.v1.FamilyService.UndoAddedParametersToSpecificFamilies
   */
  undoAddedParametersToSpecificFamilies: {
    methodKind: "unary";
    input: typeof UndoAddedParametersToSpecificFamiliesRequestSchema;
    output: typeof UndoAddedParametersToSpecificFamiliesResponseSchema;
  },
  /**
   * Start family parameter undo as a host operation with live progress.
   *
   * @generated from rpc pipeex.family.v1.FamilyService.StartUndoAddedParametersToSpecificFamilies
   */
  startUndoAddedParametersToSpecificFamilies: {
    methodKind: "unary";
    input: typeof UndoAddedParametersToSpecificFamiliesRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Combined endpoint: returns families + available parameters catalog in one call.
   * Optimized for QuickFill initialization — one round-trip through RevitTaskScheduler.
   *
   * @generated from rpc pipeex.family.v1.FamilyService.GetQuickFillData
   */
  getQuickFillData: {
    methodKind: "unary";
    input: typeof GetQuickFillDataRequestSchema;
    output: typeof GetQuickFillDataResponseSchema;
  },
  /**
   * Start QuickFill load as a host operation with live progress.
   *
   * @generated from rpc pipeex.family.v1.FamilyService.StartQuickFillLoad
   */
  startQuickFillLoad: {
    methodKind: "unary";
    input: typeof GetQuickFillDataRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Start QuickFill apply as one host operation with live progress.
   *
   * @generated from rpc pipeex.family.v1.FamilyService.StartQuickFillApply
   */
  startQuickFillApply: {
    methodKind: "unary";
    input: typeof StartQuickFillApplyRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Authoritative backend verdict for Mapping family-scope parameter
   * requirements, evaluated against live Revit evidence on the configured
   * destination/binding route of each requirement.
   *
   * @generated from rpc pipeex.family.v1.FamilyService.AssessMappingFamilyRequirements
   */
  assessMappingFamilyRequirements: {
    methodKind: "unary";
    input: typeof FamilyRequirementAssessmentRequestSchema;
    output: typeof FamilyRequirementAssessmentResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_family_service, 0);

